// The anonymous device ID (CLAUDE.md: Players are identified by an anonymous
// device ID).
//
// A random code made on this device the first time it is needed and kept in
// its storage. It identifies the browser, not the person: there are no
// accounts, nothing about the player goes into it, and two devices are two
// players — accepted. It is what makes "one result per device per puzzle" a
// rule the server can keep (record_result).
//
// Storage that is not there is not an error: a private window gets a fresh code
// for the visit, which is the same as a new device.
export const DEVICE_KEY = 'cinemore-device';
const KEY = DEVICE_KEY;

let memory: string | null = null;

function fresh(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  // Older browsers: a version-4 UUID from Math.random. It only has to be
  // unlikely to collide, not secret.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function deviceId(): string {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored && /^[0-9a-f-]{36}$/i.test(stored)) return stored;
    const made = fresh();
    localStorage.setItem(KEY, made);
    return made;
  } catch {
    memory ??= fresh();
    return memory;
  }
}

/**
 * Clear everything Cinemore keeps on this device — saved games, finished games,
 * the device id — except the keys named in `keep`. The next game is played as
 * a new device with a new id.
 */
export function forgetDevice(keep: string[] = []): void {
  memory = null;
  try {
    for (const k of Object.keys(localStorage)) {
      if (k.startsWith('cinemore-') && !keep.includes(k)) localStorage.removeItem(k);
    }
  } catch { /* nothing stored, nothing to clear */ }
}
